<template>
  <a-form-model
    ref="form"
    class="sync-config-form"
    :class="{ 'is-readonly': disabled }"
    :model="form"
    :rules="disabled ? {} : rules"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
  >
    <div class="section-block">
      <div class="section-title">价格规则</div>
      <div class="price-table">
        <div class="price-table-header">
          <div class="col-left">本系统价格</div>
          <div class="col-right">千擎系统价格</div>
        </div>
        <div class="price-table-row">
          <div class="col-left">建议销售价</div>
          <div class="col-right">
            <span class="eq">=</span>
            <span>销售价</span>
          </div>
        </div>
        <div class="price-table-row">
          <div class="col-left">同行价</div>
          <div class="col-right">
            <span class="eq">=</span>
            <span>销售价 *</span>
            <a-form-model-item
              prop="peerPriceRate"
              class="inline-item"
              :label-col="{ span: 0 }"
              :wrapper-col="{ span: 24 }"
            >
              <a-input-number
                v-model="form.peerPriceRate"
                :min="1"
                :max="100"
                :precision="0"
                :disabled="disabled"
                size="small"
              />
            </a-form-model-item>
            <span>%</span>
          </div>
        </div>
        <div class="price-table-row">
          <div class="col-left">佣金</div>
          <div class="col-right">
            <span class="eq">=</span>
            <span>(销售价 - 同行价) *</span>
            <a-form-model-item
              prop="commissionRate"
              class="inline-item"
              :label-col="{ span: 0 }"
              :wrapper-col="{ span: 24 }"
            >
              <a-input-number
                v-model="form.commissionRate"
                :min="0"
                :max="100"
                :precision="0"
                :disabled="disabled"
                size="small"
              />
            </a-form-model-item>
            <span>%</span>
          </div>
        </div>
        <div class="price-table-row">
          <div class="col-left">市场价</div>
          <div class="col-right">
            <span class="eq">=</span>
            <span>销售价 *</span>
            <a-form-model-item
              prop="marketPriceRate"
              class="inline-item"
              :label-col="{ span: 0 }"
              :wrapper-col="{ span: 24 }"
            >
              <a-input-number
                v-model="form.marketPriceRate"
                :min="100"
                :max="1000"
                :precision="0"
                :disabled="disabled"
                size="small"
              />
            </a-form-model-item>
            <span>%</span>
          </div>
        </div>
        <div class="price-table-row">
          <div class="col-left">采购价</div>
          <div class="col-right">
            <span class="eq">=</span>
            <span>销售价 *</span>
            <a-form-model-item
              prop="purchasePriceRate"
              class="inline-item"
              :label-col="{ span: 0 }"
              :wrapper-col="{ span: 24 }"
            >
              <a-input-number
                v-model="form.purchasePriceRate"
                :min="1"
                :max="100"
                :precision="0"
                :disabled="disabled"
                size="small"
              />
            </a-form-model-item>
            <span>%</span>
          </div>
        </div>
      </div>
    </div>

    <div class="section-block">
      <div class="section-title">同步设置</div>
      <a-form-model-item label="任务名称" prop="taskName">
        <a-input
          v-model="form.taskName"
          :disabled="disabled"
          allowClear
          placeholder="请输入任务名称，不填默认为「默认任务」"
          :maxLength="50"
          style="max-width: 360px"
        />
      </a-form-model-item>
      <a-form-model-item label="同步商品" prop="syncType">
        <a-radio-group v-model="form.syncType" :disabled="disabled">
          <a-radio :value="1">全量同步</a-radio>
          <a-radio :value="2">指定商品</a-radio>
        </a-radio-group>
        <div v-if="form.syncType === 2" class="product-ids-wrap">
          <a-textarea
            v-model="form.productIds"
            class="product-ids-textarea"
            :rows="5"
            :disabled="disabled"
            placeholder="千擎资源ID，一行一个"
          />
        </div>
      </a-form-model-item>
      <a-form-model-item label="商品信息" prop="productInfoInterval">
        <span class="inline-text">每</span>
        <a-input-number
          v-model="form.productInfoInterval"
          :min="5"
          :precision="0"
          :disabled="disabled"
          size="small"
          class="interval-input"
        />
        <span class="inline-text">分钟更新一次；</span>
        <a-radio-group v-model="form.productInfoStrategy" class="strategy-group" :disabled="disabled">
          <a-radio :value="1">每次更新</a-radio>
          <a-radio :value="2">仅首次更新</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="价格库存" prop="priceStockInterval">
        <span class="inline-text">每</span>
        <a-input-number
          v-model="form.priceStockInterval"
          :min="5"
          :precision="0"
          :disabled="disabled"
          size="small"
          class="interval-input"
        />
        <span class="inline-text">分钟更新一次；</span>
        <a-radio-group v-model="form.priceStockStrategy" class="strategy-group" :disabled="disabled">
          <a-radio :value="1">每次更新价格库存</a-radio>
          <a-radio :value="2">每次仅更新库存，不更新价格</a-radio>
        </a-radio-group>
      </a-form-model-item>
    </div>
  </a-form-model>
</template>

<script>
import { createSyncConfigForm, syncConfigFormRules } from '../utils/syncConfigHelper'

export default {
  name: 'SyncConfigForm',
  props: {
    value: {
      type: Object,
      default: () => createSyncConfigForm()
    },
    disabled: {
      type: Boolean,
      default: false
    },
    labelCol: {
      type: Object,
      default: () => ({ span: 3 })
    },
    wrapperCol: {
      type: Object,
      default: () => ({ span: 18 })
    }
  },
  data () {
    return {
      rules: syncConfigFormRules
    }
  },
  computed: {
    form: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    validate () {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => resolve(valid))
      })
    },
    clearValidate () {
      this.$refs.form && this.$refs.form.clearValidate()
    }
  }
}
</script>

<style scoped lang="less">
.section-block {
  margin-bottom: 28px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e8e8e8;
}

.price-table {
  width: 100%;
  max-width: 720px;
  border: 1px solid #e8e8e8;
  margin-bottom: 12px;

  .price-table-header,
  .price-table-row {
    display: flex;
    align-items: center;
    min-height: 48px;
    border-bottom: 1px solid #e8e8e8;

    &:last-child {
      border-bottom: none;
    }
  }

  .price-table-header {
    background: #fafafa;
    font-weight: 600;
  }

  .col-left {
    width: 140px;
    flex-shrink: 0;
    text-align: right;
    padding: 8px 16px;
    background: #f7f7f7;
    box-sizing: border-box;
  }

  .price-table-header .col-left {
    background: #fafafa;
  }

  .col-right {
    flex: 1;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    padding: 8px 16px;
    gap: 6px;
    box-sizing: border-box;
  }

  .eq {
    margin-right: 2px;
  }
}

.inline-item {
  display: inline-block !important;
  margin: 0 4px !important;
  width: auto !important;
  vertical-align: middle;

  /deep/ .ant-form-item-label {
    display: none;
  }

  /deep/ .ant-row {
    display: inline-flex;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  /deep/ .ant-form-item-control-wrapper,
  /deep/ .ant-col {
    width: auto !important;
    float: none !important;
    padding: 0 !important;
  }

  /deep/ .ant-form-item-control {
    line-height: 32px;
  }

  /deep/ .ant-form-explain {
    position: absolute;
    white-space: nowrap;
  }
}

.product-ids-wrap {
  margin-top: 12px;
  width: 100%;
}

.product-ids-textarea {
  display: block;
  max-width: 480px;
}

.inline-text {
  color: rgba(0, 0, 0, 0.65);
}

.interval-input {
  width: 80px;
  margin: 0 8px;
}

.strategy-group {
  margin-left: 8px;
}
</style>
